/**
 * "¿Qué hay de nuevo?" — shown once per version the next time a signed-in
 * person opens the app, and always available from Ajustes. When Álvaro says
 * "vamos a actualizarlo": bump WHATS_NEW_VERSION (the date), give the release
 * its number and name, rewrite the items — everybody sees it again, with meow.
 */
export const WHATS_NEW_VERSION = '2026-09-21'
const SEEN_KEY = 'catgo.whatsnew-seen'

export type Jelly = 'naranja' | 'menta' | 'violeta' | 'rosa'

export interface WhatsNewItem {
  emoji: string
  jelly: Jelly
  text: string
}

export const WHATS_NEW = {
  /** The release, as people will quote it. */
  number: '1.1',
  name: 'Siete vidas',
  date: '21 de septiembre de 2026',
  kicker: '✨ NOVEDADES',
  title: 'CatGO! estrena sus siete vidas',
  items: [
    { emoji: '🗺️', jelly: 'naranja', text: 'El mapa guarda mejor dónde viste a cada gato' },
    { emoji: '🧭', jelly: 'menta', text: '¿Aún no has salido a la calle? Te espera tu primera misión' },
    { emoji: '🛟', jelly: 'violeta', text: 'Tus gatos y tus fotos ya tienen copia de seguridad' },
    { emoji: '📝', jelly: 'rosa', text: 'Castrado, no castrado o sin información, en la ficha' },
  ] as WhatsNewItem[],
  cta: '¡Vamos!',
}

export function hasSeenWhatsNew(): boolean {
  try {
    return localStorage.getItem(SEEN_KEY) === WHATS_NEW_VERSION
  } catch {
    return true // a browser that forgets should not nag
  }
}

export function markWhatsNewSeen(): void {
  try {
    localStorage.setItem(SEEN_KEY, WHATS_NEW_VERSION)
  } catch {
    /* nothing to remember with */
  }
}
